"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

function createCn(blockName, className, theme) {
  return function (elementNameOrMods, mods) {
    if (typeof elementNameOrMods === 'string') {
      // create an element className
      var out_1 = blockName + "__" + elementNameOrMods;

      if (mods) {
        return "" + out_1 + createModifiersString(out_1, mods);
      }

      return out_1;
    }

    var out = blockName;

    if (theme) {
      elementNameOrMods = __assign(__assign({}, elementNameOrMods), {
        theme: theme
      });
    }

    if (typeof className === 'string') {
      // external className provided as factory argument
      out += " " + className;
    } else if (typeof this === 'object' && this.props) {
      // external className from props
      if (this.props.className && typeof this.props.className === 'string') {
        out += " " + this.props.className;
      }

      if (this.props.theme && typeof this.props.theme === 'string') {
        elementNameOrMods = __assign(__assign({}, elementNameOrMods), {
          theme: this.props.theme
        });
      }
    }

    if (elementNameOrMods) {
      return "" + out + createModifiersString(blockName, elementNameOrMods);
    }

    return out;
  };
}

exports.createCn = createCn;

function createModifiersString(blockName, elemOrMode) {
  return Object.keys(elemOrMode).reduce(function (prev, curr) {
    var value = elemOrMode[curr];

    if (typeof value === 'string' || typeof value === 'number') {
      return prev + " " + blockName + "_" + curr + "_" + value;
    }

    if (value) {
      return prev + " " + blockName + "_" + curr;
    }

    return prev;
  }, '');
}